import React, { useRef, useState, useEffect } from 'react';
import useScrollSpy from '../hooks/useScrollSpy';
import './Work.css';

import OverviewPL from './Work/Overview/OverviewPL';
import MyRolePL from './Work/MyRole/MyRolePL';
import MyUXProcessPL from './Work/MyUXProcess/MyUXProcessPL';
import UseCasesPL from './Work/UseCases/UseCasesPL';

import SidebarPL from '../components/Sidebar/SidebarPL';

function WorkPL() {
  const sectionIds = [
    'overview',
    'myrole',
    'myuxprocess',
    'usecases',

    'devtools-overview',
    'devtools-specification',
    'devtools-problem',
    'devtools-process',
    'devtools-solution',
    'devtools-designfeatures',
    'devtools-conclusion',

    'desktopapp-overview',
    'desktopapp-specification',
    'desktopapp-problem',
    'desktopapp-process',
    'desktopapp-solution',
    'desktopapp-conclusion',

    'mobileapp-overview',
    'mobileapp-specification',
    'mobileapp-problem',
    'mobileapp-process',
    'mobileapp-solution',
    'mobileapp-designfeatures',
    'mobileapp-conclusion'
  ];
  const activeSection = useScrollSpy(sectionIds);
  const [selectedCase, setSelectedCase] = useState(null);

  // Create a ref for the UseCases component
  const useCasesRef = useRef(null);

  // Update selectedCase based on activeSection
  useEffect(() => {
    if (!activeSection) return;
    
    if (activeSection.startsWith('devtools-')) {
      setSelectedCase('devtools');
    } else if (activeSection.startsWith('desktopapp-')) {
      setSelectedCase('desktopapp');
    } else if (activeSection.startsWith('mobileapp-')) {
      setSelectedCase('mobileapp');
    } else {
      setSelectedCase(null);
    }
  }, [activeSection]);

  return (
    <div className="work-container">
      <SidebarPL activeSection={activeSection} selectedCase={selectedCase} useCasesRef={useCasesRef} />

      <div className="work-content">
        <section id="overview">
          <OverviewPL />
        </section>
        <section id="myrole">
          <MyRolePL />
        </section>
        <section id="myuxprocess">
          <MyUXProcessPL />
        </section>
        <section id="usecases">
          <UseCasesPL ref={useCasesRef} onCaseSelect={setSelectedCase} />
        </section>
      </div>
    </div>
  );
}

export default WorkPL; 